// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3tQ7W","messages":"Chat_messages__IRjfu","dateDivider":"Chat_dateDivider__I7ggk"};